/**
 * Detail facts container.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const DetailFactsContainer = styled.div`
  align-self: stretch;
  box-sizing: border-box;
  display: block;
  margin-bottom: ${12 * Screen.widthRatio}px;
  max-width: ${1020 * Screen.widthRatio}px;
`;

export default DetailFactsContainer;
